<template>
  <div id="insights" class="page-container">
    <div class="page-content">
      <div class="flex-row-center mt-16">
        <img src="../assets/images/navbar/ic_insights.webp" class="icon-pages" />
        <span class="page-title">{{ $t("page.insights") }}</span>
        <span class="page-des page-des-line">{{
          $t("page.insights_description")
        }}</span>
      </div>

      <el-tabs
        class="style-bar"
        v-model="activeName"
        :before-leave="onTabBeforeLeave"
        @tab-click="forceRerender"
      >
        <el-tab-pane :name="anchor.dashboard">
          <span slot="label" class="title-bar">{{ $t("page.dashboard") }}</span>
          <dashboard
            v-if="hasVisitedDashboard"
            v-show="activeName == 'dashboard'"
            :tabActive="activeName"
            @changedTab="onChangedTab"
          ></dashboard>
        </el-tab-pane>
        <el-tab-pane :name="anchor.teams">
          <span slot="label" class="title-bar">
            {{ $t("page.teams") }}
            <span v-if="isFreePlan" class="tab-pro-badge">PRO</span>
          </span>
          <teams
            v-if="renderComponent == false && activeName == 'teams'"
          ></teams>
        </el-tab-pane>
        <el-tab-pane
          :name="anchor.cohorts"
          v-if="user && user.user_type !== 'leadership'"
        >
          <span slot="label" class="title-bar">
            {{ $t("page.cohorts") }}
            <span v-if="isFreePlan" class="tab-pro-badge">PRO</span>
          </span>
          <cohorts
            v-if="renderComponent == false && activeName == 'cohorts'"
          ></cohorts>
        </el-tab-pane>
        <el-tab-pane :name="anchor.managers">
          <span slot="label" class="title-bar">
            {{ $t("page.managers") }}
            <span v-if="isFreePlan" class="tab-pro-badge">PRO</span>
          </span>
          <managers2
            v-if="renderComponent == false && activeName == 'managers'"
          ></managers2>
        </el-tab-pane>
        <el-tab-pane :name="anchor.people">
          <span slot="label" class="title-bar">
            {{ $t("page.people") }}
            <span v-if="isFreePlan" class="tab-pro-badge">PRO</span>
          </span>
          <people v-if="renderComponent == false && activeName == 'people'"></people>
        </el-tab-pane>
        <el-tab-pane :name="anchor.relationships">
          <span slot="label" class="title-bar">
            {{ $t('insights.Relationships') }}
            <span v-if="isFreePlan" class="tab-pro-badge">PRO</span>
          </span>
          <relationships v-if="renderComponent == false && activeName == 'relationships'"></relationships>
        </el-tab-pane>
        <el-tab-pane :name="anchor.report">
          <span slot="label" class="title-bar">
            {{ $t("page.reportCard") }}
            <span v-if="isFreePlan" class="tab-pro-badge">PRO</span>
          </span>
          <report
            v-if="renderComponent == false && activeName == 'report'"
          ></report>
        </el-tab-pane>
      </el-tabs>
      <upgrade-modal
        :visible.sync="upgradeModalVisible"
        :feature-name="upgradeModalFeature"
        @close="upgradeModalVisible = false"
      />
      <component
        v-if="
          (activeName == 'teams' ||
            activeName == 'report' ||
            activeName == 'managers') &&
          renderComponent
        "
        v-bind:is="activeName"
      ></component>
    </div>
  </div>
</template>

<script>
import UpgradeModal from "@/components/main/UpgradeModal.vue";
const FREE_INSIGHTS_TAB_LABELS = {
  teams: "Teams insights",
  cohorts: "Cohorts insights",
  managers: "Managers insights",
  people: "People insights",
  relationships: "Relationships insights",
  report: "Report card",
};
export default {
  name: "insights",
  components: {
    dashboard: require("./insights/dashboard").default,
    teams: require("./insights/teams").default,
    cohorts: require("./insights/cohorts").default,
    managers2: require("./insights/managers").default,
    people: require("./insights/people").default,
    relationships: () => import(/* webpackChunkName: "insights-relationships" */ "./insights/relationships.vue"),
    report: require("./insights/report").default,
    "upgrade-modal": UpgradeModal,
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    isFreePlan() {
      return !!(this.user && this.user.plan_tier === "free");
    },
    dimension() {
      return this.$store.getters["insights/dimension"];
    },
    loadpage() {
      return this.$store.getters["people/loadpage"];
    },
  },
  watch: {
    activeName() {
      if (this.activeName != "") {
        const tab = this.activeName || "";
        const paramsTab = this.$router.currentRoute.params.tab;
        if (tab == "dashboard") {
          this.hasVisitedDashboard = true;
        }
        this.forceRerender();
        if (paramsTab != tab) {
          this.$router.push({ name: "insightsWithTab", params: { tab } });
        }
      }
    },
  },
  data() {
    const route = this.$route || {};
    const params = route.params || {};
    const query = route.query || {};
    const availableTabs = [
      "dashboard",
      "teams",
      "cohorts",
      "managers",
      "people",
      "relationships",
      "report",
    ];
    let activeName =
      query.welcome != "true" && availableTabs.indexOf(params.tab) !== -1
        ? params.tab
        : "dashboard";
    const user = this.$store && this.$store.getters
      ? this.$store.getters["authen/user"]
      : null;

    if (user && user.plan_tier === "free" && activeName !== "dashboard") {
      activeName = "dashboard";
    }

    return {
      activeName,
      anchor: {
        dashboard: "dashboard",
        teams: "teams",
        cohorts: "cohorts",
        managers: "managers",
        people: "people",
        report: "report",
        relationships: "relationships",
      },
      renderComponent: false,
      hasVisitedDashboard: activeName == "dashboard",
      upgradeModalVisible: false,
      upgradeModalFeature: "",
    };
  },
  mounted() {
    const params = this.$router.currentRoute.params.tab;
    if (this.$route.query.welcome == "true") {
      this.$router.push({
        name: "insightsWithTab",
        params: { tab: "dashboard" },
        query: { welcome: "false" },
      });
    }
    if (params && this.anchor[params] && !this.$route.query.welcome) {
      // Free plan: only the dashboard tab is accessible. Redirect any
      // other initial tab (deep link, history) back to dashboard and
      // surface the upgrade prompt so the user knows why.
      if (this.isFreePlan && params !== "dashboard") {
        this.activeName = "dashboard";
        this.$router.replace({
          name: "insightsWithTab",
          params: { tab: "dashboard" },
        }).catch(() => {});
        this.upgradeModalFeature = FREE_INSIGHTS_TAB_LABELS[params] || "Insights tabs";
        this.upgradeModalVisible = true;
      } else {
        this.activeName = params;
      }
    } else if (!this.$route.query.welcome) {
      this.$router.push({
        name: "insightsWithTab",
        params: { tab: "dashboard" },
      });
    }
    this.scroll();
    this.rootChangeTabHandler = (item) => {
      if (item.path == "insights") {
        this.onChangedTab(item);
      }
    };
    this.$root.$on('changeTab', this.rootChangeTabHandler);
  },
  beforeDestroy() {
    if (this.rootChangeTabHandler) {
      this.$root.$off('changeTab', this.rootChangeTabHandler);
    }
    if (this.boundOnWindowScroll) {
      window.removeEventListener('scroll', this.boundOnWindowScroll);
      this.boundOnWindowScroll = null;
    }
  },
  methods: {
    scroll() {
      if (this.boundOnWindowScroll) {
        window.removeEventListener('scroll', this.boundOnWindowScroll);
      }
      this.boundOnWindowScroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop +
            document.documentElement.clientHeight >=
          document.documentElement.scrollHeight;
        if (bottomOfWindow) {
          if (this.loadpage) {
            if (this.activeName == "people") {
              this.nextMember();
            }
          }
        }
      };
      window.addEventListener('scroll', this.boundOnWindowScroll, { passive: true });
    },
    onTabBeforeLeave(targetName) {
      // Free plan: only 'dashboard' is reachable. Block the switch and
      // open the upgrade modal so the user understands what's happening.
      if (this.isFreePlan && targetName !== "dashboard") {
        this.upgradeModalFeature = FREE_INSIGHTS_TAB_LABELS[targetName] || "Insights tabs";
        this.upgradeModalVisible = true;
        return false;
      }
      return true;
    },
    forceRerender() {
      let activeTab = this.activeName;
      if (
        (activeTab == "teams" ||
          activeTab == "report" ||
          activeTab == "managers" ||
          activeTab == "cohorts" ||
          activeTab == "people" ||
          activeTab == "relationships") &&
        this.renderComponent == true
      ) {
        this.renderComponent = false;
      }
    },
    getImgUrl(pic) {
      var images = require.context(
        "../assets/images/spotlight/",
        false,
        /\.png$/
      );
      return images("./" + pic + ".png");
    },
    nextMember() {
      this.$store.dispatch("people/nextMember");
    },
    onChangedTab(value) {
      this.activeName = value.tab;
    },
  },
};
</script>
<style scoped></style>
<style>
#insights .el-tabs__item {
  height: 52px;
  line-height: 52px;
  width: 132px;
  text-align: center;
  font-family: 'Lato', 'Kanit', Arial, sans-serif;
}
#insights .el-tabs__header {
  margin: 0px;
}
#insights .tab-pro-badge {
  display: inline-block;
  margin-left: 6px;
  padding: 0 7px;
  height: 16px;
  line-height: 16px;
  border-radius: 8px;
  background: linear-gradient(135deg, #FFD66B, #FFC200);
  color: #2A1A05;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.10em;
  vertical-align: middle;
  font-family: 'Lato', 'Kanit', sans-serif;
  box-shadow: 0 1px 4px rgba(255, 194, 0, 0.30);
}
</style>
